<template>
  <div
    class="vx-card flex justify-center items-center flex-col relative"
    style="min-height: 400px"
  >
    <h5 class="w-full absolute p-4 text-lg z-10" style="top: 10px; right: 10px">
      وضعیت مرسولات ماه جاری
    </h5>
    <div
      class="flex w-full justify-center items-center flex-col gap-8"
      v-if="showChart"
    >
      <vue-apex-charts
        type="donut"
        height="200"
        :options="chartOptions"
        :series="series"
      />
      <div class="grid grid-cols-2 gap-y-1 gap-x-2 items-center px-2">
        <div
          class="gap-2 items-center cursor-default"
          v-for="item of chartColors"
          :key="item.hexColor"
        >
          <vx-tooltip :title="item.label" position="top" :color="item.hexColor">
            <div class="flex gap-2 items-center">
              <div
                class="w-6 h-6 rounded-full"
                :style="{ backgroundColor: item.hexColor }"
              ></div>
              <span class="text-sm">{{ item.label }}</span>
            </div>
            <template slot="content">
              <div
                style="direction: ltr"
                class="flex text-center w-full justify-center flex-col font-bold"
              >
                <div>
                  <span>{{ item.value.toLocaleString() }}</span>
                </div>
              </div>
            </template>
          </vx-tooltip>
        </div>
      </div>
    </div>

    <Shimmer v-else class="w-full h-full"></Shimmer>
  </div>
</template>

<script>
import Shimmer from "@/components/Shimmer.vue";
import VueApexCharts from "vue-apexcharts";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      showChart: false,
      chartColors: [],
      series: [],
      chartOptions: {
        labels: [],
        dataLabels: {
          enabled: false,
        },
        legend: { show: false },
        chart: {
          fontFamily: "IRANSans",
          type: "donut",
          dropShadow: {
            enabled: false,
            blur: 5,
            left: 1,
            top: 1,
            opacity: 0.2,
          },
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: 0.5,
        },
        colors: [],
        fill: {},
      },
    };
  },
  methods: {
    ...mapActions({
      fetchPackageStatesChartData: "reports/fetchPackageStatesChartData",
    }),
  },
  mounted() {
    this.fetchPackageStatesChartData().then((response) => {
      let lables = [
        "در انتظار ثبت اپراتور",
        "در انتظار تایید اپراتور",
        "در انتظار تحویل به مشتری",
        "تحویل داده شده",
      ];
      let datasets = [
        response.countOfWaitingForAssignOperator,
        response.countOfOperatorAssigned,
        response.countOfOperatorApproved,
        response.countOfDelivered,
      ];
      const colors = ["#FF69B4", "#8A2BE2", "#FF6347", "#3CB371"];
      datasets.forEach((item, index) => {
        this.chartOptions.colors.push(colors[index]);
        this.chartColors.push({
          hexColor: colors[index],
          label: lables[index],
          value: datasets[index],
        });
      });
      this.chartOptions.labels = lables;
      this.series = datasets;
      this.showChart = true;
    });
  },
  components: {
    Shimmer,
    VueApexCharts,
  },
};
</script>

<style scoped></style>
